import React from 'react';
import PropTypes from 'prop-types';

import { useNavigate } from "react-router-dom";

import withStyles from '@mui/styles/withStyles';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';

const styles = {
    root: {
        position: 'fixed',

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        flexFlow: 'row wrap',

        top: '15%',
        height: '70%',
        width: '100%'
    },
    row: {
        flexBasis: '100%'
    }
};

const Page404 = ({ classes }) => {

    const navigate = useNavigate();

    const handleClick = () => {
        navigate(-2);
    };

    return (
        <div className={classes.root}>
            <Typography className={classes.row} align="center" variant="h3">404</Typography>
            <Typography className={classes.row} align="center" variant="h5">{`L'élément cherché n'existe pas, n'existe plus ou vous n'êtes pas autorisé à le consulter.`}</Typography>
            <Button onClick={handleClick} variant="contained" color="secondary">Retour</Button>
        </div>
    );
};

Page404.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Page404);